export default "__VITE_ASSET__DZLEN1Yg__"